/**
 * RastreamentoHistoricoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {RastreamentoHistorico} from '@/model/resource/RastreamentoHistorico'

/* TODO: review generated class */
@HttpExclude()
export class RastreamentoHistoricoCollection extends PageCollection<
  RastreamentoHistorico
> {
  constructor() {
    super(RastreamentoHistorico)
  }

  queryAsPage() {
    return this.listRastreamentoHistorico()
  }

  async listRastreamentoHistorico() {
    return await Request.get(`/admin/rastreamento-historico`, {
      params: this.params,
    })
      .name('listRastreamentoHistorico')
      .as(this)
      .getResponse()
  }

  async listCsvRastreamentoHistorico() {
    return await Request.get(`/admin/rastreamento-historico/csv`, {
      params: this.params,
    })
      .name('listCsvRastreamentoHistorico')
      .as(this)
      .getResponse()
  }
}
